import {z} from 'zod';

import {convertStringToColour} from '../../functions/convertStringToColour';
import {addSlug} from '../../functions/slugify';

export const tagSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    modified: z.coerce.date(),
    isArchived: z.boolean().catch(false),
  })
  .transform(addSlug)
  .transform((tag) => ({
    ...tag,
    colour: convertStringToColour(tag.id),
  }));
